import { render } from "preact"
import { App } from "./components/App"
import { ConfirmProvider } from "./components/Confirm"
import { ToastProvider } from "./components/Toast"

if ("serviceWorker" in navigator) {
	navigator.serviceWorker.register("/sw.js").catch(() => {})
}

render(
	<ToastProvider>
		<ConfirmProvider>
			<App />
		</ConfirmProvider>
	</ToastProvider>,
	document.getElementById("app")!,
)
